import { render, staticRenderFns } from "./IDCardPreviewPopup.vue?vue&type=template&id=4aa628d9&"
import script from "./IDCardPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./IDCardPreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports